export * from './tab.component';
export * from './tabs.component';
export * from './dynamic-tabs.directive';
